import { CampaignVars } from './../../marketing/google/CampaignVars';
/**
 * Copyright © 2012 Goodgame Studios. All rights reserved.
 *
 * Created with IntelliJ IDEA
 * Creator: Patrick
 * Created: 25.07.12, 17:00
 *
 * $URL$
 * $Rev$
 * $Author$
 * $Date$
 * $Id$
 */


import { EnvGlobalsHandler } from "../EnvGlobalsHandler";
import { IEnvironmentGlobals } from "../IEnvironmentGlobals";
export class BasicTrackingStringComposer {
    /**
     * Composes a semicolon separated string for the registration
     *
     *
     *
     * Order:
     * var_data[0] = email
     * var_data[1] = referrer
     *
     * var_data[2] = placement
     * var_data[3] = keyword
     * var_data[4] = network
     * var_data[5] = channelId (cid)
     * var_data[6] = trafficSource (tid)
     * var_data[7] = camp
     * var_data[8] = adgr
     * var_data[9] = matchtype
     * var_data[10] = journeyHash
     * var_data[11] = websiteId
     *
     * For details about the order of the values see tracking structure registration event:
     * @see http://goo.gl/2XKD5U googledocs
     */
    public static composeVarDataForRegistration(email: string, referrer: string): string {
        let cv: CampaignVars = BasicTrackingStringComposer.env.campainVars;

        let varDataRegistration: any[] = [];

        // email
        varDataRegistration[0] = email;

        // referrer
        varDataRegistration[1] = referrer;

        // campaign vars
        varDataRegistration[2] = cv.placement;
        varDataRegistration[3] = cv.keyword;
        varDataRegistration[4] = cv.network;
        varDataRegistration[5] = cv.channelId;
        varDataRegistration[6] = cv.trafficSource;
        varDataRegistration[7] = cv.camp;
        varDataRegistration[8] = cv.adgr;
        varDataRegistration[9] = cv.matchtype;
        varDataRegistration[10] = BasicTrackingStringComposer.env.jsVariables.journeyHash;
        varDataRegistration[11] = BasicTrackingStringComposer.env.urlVariables.websiteId;

        return varDataRegistration.join(CampaignVars.DEFAULT_DELIMITER);
    }

    private static get env(): IEnvironmentGlobals {
        return EnvGlobalsHandler.globals;
    }
}

